import React from "react";
import SelectFormField from "../../global/SelectFormField/SelectFormField";
import { Controller } from "react-hook-form";
import UploadDragDocument from "../../global/UploadDocument/UploadDragDocument";
import { useSelector } from "react-redux";
import { orderSummarySelector } from "../../../features/ordersSummary/orderSummarySlice";
function MissingDocsUploadForm({
  control,
  values,
  register,
  errors,
  handleChange,
  dropdownChange,
  setValue,
  trigger,
  getValues,
  t,
  propertyArray,
  documentTypeArray,
  reset,
}) {
  const { editOrderDetails } = useSelector(orderSummarySelector);
  return (
    <>
      <div className="flex flex-row mt-4">
        <div className="mr-8 w-[388px]">
          <SelectFormField
            label={t("DocumentType")}
            options={documentTypeArray.sort((a, b) =>
              a.label.localeCompare(b.label)
            )}
            dropdownChange={dropdownChange}
            currentValue={values.document_type}
            control={control}
            fieldName="document_type"
            errorMessage={errors.document_type && t("RequiredFieldErrMsg")}
            ariaLabel="dropdownDocument_type"
            labelClassNames="inline mb-2 font-[500] font-open-sans"
            labelCustomStyle={{ width: "max-content" }}
            selectClassNames="custom__dropdown-wrapper w-[300px]"
          />
        </div>
        {propertyArray?.length > 1 && (
          <div className="mr-4">
            <SelectFormField
              label={t("property")}
              options={propertyArray}
              dropdownChange={dropdownChange}
              currentValue={values.property}
              control={control}
              fieldName="property"
              errorMessage={errors.property && t("RequiredFieldErrMsg")}
              ariaLabel="dropdownResidential"
              labelClassNames="block mb-2 font-[500] font-open-sans"
              labelCustomStyle={{ marginLeft: 40 }}
              selectClassNames="custom__dropdown-wrapper w-[300px]"
            />
          </div>
        )}
      </div>
      <UploadDragDocument
        fieldName={`AdditionalDocuments`}
        control={control}
        Controller={Controller}
        trigger={trigger}
        setValue={setValue}
        sectionName="DocumentUpload"
        documentType={values.document_type}
        propertyId={
          editOrderDetails?.propertyList?.length === 1
            ? editOrderDetails?.propertyList[0]?.id
            : values?.property
        }
        selectedProperty={propertyArray?.filter(
          (item) => item.value == values?.property
        )}
        propertyNumber={
          propertyArray?.length === 1
            ? "1"
            : editOrderDetails?.propertyList?.filter(
                (prop) => prop?.id === values?.property
              )?.propertyPosition
        }
        propertyDependent
        propertyArray={propertyArray}
        summaryPage={
          window?.location?.href?.includes("ordersummary") ||
          window?.location?.href?.includes("policypickup")
        }
        reset={reset}
        documentTypeArray={documentTypeArray}
      />
    </>
  );
}

export default React.memo(MissingDocsUploadForm);
